module.exports = __webpack_public_path__ + "static/media/012-Brother's Tavern.d1ebc77a.png";